export interface ApiErrorBody {
  error: string;
  message: string;
  details?: Record<string, unknown> | null;
}

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly body: ApiErrorBody,
  ) {
    super(body.message);
    this.name = 'ApiError';
  }
  get code() {
    return this.body.error;
  }
}

export interface Session {
  accessToken: string;
  accessExpiresAt: number;
  refreshToken: string;
  refreshExpiresAt: number;
  user: { id: string; phone: string; role: 'driver' | 'admin' | 'passenger'; fullName: string | null; isNew: boolean };
}

export interface Me {
  id: string;
  phone: string;
  role: 'driver' | 'admin' | 'passenger';
  fullName: string | null;
  email: string | null;
  driver: {
    id: string;
    handle: string | null;
    displayName: string | null;
    pageLive: boolean;
    planStatus: string;
  } | null;
}
